<template lang="pug">
  v-container
    p hola {{text}}
</template>

<script>
  export default {
    data () {
      return {
        text: 'mundo'
      }
    },
    mounted () {
      let time = this.$moment().format()
      console.log(time)
    }
  }
</script>

<style>

</style>
